import { render, staticRenderFns } from "./chapter_add_update.vue?vue&type=template&id=a3050c40&scoped=true"
import script from "./chapter_add_update.vue?vue&type=script&lang=js"
export * from "./chapter_add_update.vue?vue&type=script&lang=js"
import style0 from "./chapter_add_update.vue?vue&type=style&index=0&id=a3050c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3050c40",
  null
  
)

export default component.exports